import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m7.057 12.943 8 8a1.332 1.332 0 0 0 1.885 0l8-8a1.332 1.332 0 1 0-1.885-1.885L16 18.115l-7.057-7.057a1.332 1.332 0 1 0-1.885 1.885h-.001Z" }));
const ForwardRef = forwardRef(SvgChevronDown);
export default ForwardRef;
